<template>
	<div class="page-layout-tabs scrollable">
			<el-tabs @tab-click="getTabName">
				<el-tab-pane :key="index" v-for="(key,index) in tabs" :label="key.label">
					<component :is="key.currTab"  :params="params" :item="key.label" test_id="oooooooooooooooooooooooooo" @changed="changed"></component>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
	// import datePicker from './el-date-picker.vue';
	export default {
		props: ['tabs', 'params'],
		data() {
			return {
				title: ''
			}
		},
		methods: {
			changed(val) {
				console.log(val)
				this.$emit('changed')
			},
			// tabName(val){
			// this.$emit('tabName',val);
			// },
			// getStartDate(val) {
			// 	this.$emit('start-date',val)
			// }
			// ,getEndDate(val) {
			// 	this.$emit('end-date',val)
			// },
			// back(){
			// 	this.$router.push(this.backLink);
			// },
			getTabName(val) {
				this.$emit('getTabName', val.paneName)
			}
		},
		components: {
			// datePicker,
		}
	}
</script>

<style lang="scss">
	.page-layout-tabs {
		margin-left: 20px;
		margin-right: 20px;
		.com-phone-back {
			font-size: 16px;
			color: #ec682e;
			height: 60px;
			line-height: 60px;
			width: 100%;
			display: none;
		}
		.com-top {
			clear: none;
			width: 100%;
			height: 40px;
			.back-link {
				font-size: 16px;
				color: #ec682e;
				line-height: 40px;
				float: left;
				display: block;
				width: 100px;
			}

			.tab-date-picker {
				display: block;
				float: left;
			}
		}
		.el-tabs__item {
			font-size: 12px;
			font-family: 'Muli-Regular';
		}
		.el-tabs__nav {
			margin-left: 20px;
		}
		.is-active {
			font-family: 'Muli-Bold';
			color: #ec682e !important;
		}
		.is-top {
			color: #7d7d7d;

		}
		@media (max-width: 768px) {
			.back-link {
				display: none !important;
			}
			.com-phone-back {
				display: none !important;

			}
		}
	}
</style>
